// src/utils/apiHelpers.js
import api from "../api";
import { jwtDecode } from 'jwt-decode';
import { ACCESS_TOKEN } from "../helpers/constants";


/**
 * Fetches the user ID from the JWT access token stored in localStorage.
 * @returns {Promise<string | null>} - The user ID or null if not found.
 */
export const fetchUserId = async () => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const userId = decodedToken.user_id;
        console.log("User ID:", userId);
        return userId;
      } catch (error) {
        console.error('Error decoding JWT token:', error);
        return null;
      }
    } else {
      console.error('No access token found in localStorage');
      return null;
    }
  };


  export const fetchUserCompanySetupStatus = async (userId) => {
    const url = `/api/getuserdetails/${userId}/`;  // Adjust this endpoint if needed
    try {
        const response = await api.get(url);

        // Check if user details are successfully fetched
        if (response.status === 200) {
            const userDetails = response.data;
            const isCompanySetupComplete = userDetails.is_company_setup_complete;

            console.log("is_company_setup_complete:", isCompanySetupComplete);

            // If company setup is complete, return true; otherwise, return false
            return isCompanySetupComplete;
        } else {
            console.error('Error fetching user details:', response.status);
            return false;  // Default to false if unable to fetch details
        }
    } catch (error) {
        console.error("Network error:", error);
        return false;  // Default to false on network error
    }
};


/**
 * Fetches the role from the JWT access token stored in localStorage.
 * @returns {Promise<string | null>} - The role or null if not found.
 */
export const fetchRole = async () => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const role = decodedToken.role; // Assuming the role is stored in the token
      console.log("Role:", role);
      return role;
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  } else {
    console.error('No access token found in localStorage');
    return null;
  }
};

// export const fetchCompanyId = async (userId) => {
//   const isCompanySetupComplete = await fetchUserCompanySetupStatus(userId);

//   if (isCompanySetupComplete) {
//       const url = `/api/companyid/${userId}/`;
//       try {
//           const response = await api.get(url);

//           // Check for a successful response (status code 200)
//           if (response.status === 200) {
//               const data = response.data;
//               console.log("Company ID:", data.companyId);
//               return data.companyId;
//           } else {
//               // console.error("Error fetching company ID: Unexpected status", response.status);
//               return null;
//           }
//       } catch (error) {
//           console.error("Network error:", error);
//           return null;
//       }
//   } else {
//       console.log("Company setup not complete. Skipping company ID fetch.");
//       return null;  // Skip fetching company ID if setup is not complete
//   }
// };

  

/**
 * Fetches the company ID for a given user ID.
 * @param {string | number} userId - The ID of the user.
 * @returns {Promise<string | null>} - The company ID or null if not found.
 */
export const fetchCompanyId = async (userId) => {
    const url = `/api/companyid/${userId}/`;
    try {
    const response = await api.get(url);

     // Check for a successful response (status code 200)
    if (response.status === 200) {
        const data = response.data;
        console.log("Company ID:", data.companyId);
        return data.companyId;
      } else {
        // console.error("Error fetching company ID: Unexpected status", response.status);
        return null;
      }
    } catch (error) {
      console.error("Network error:", error);
      return null;
    }
  };
  

/**
 * Fetches the company ID for a given user ID.
 * @param {string | number} userId - The ID of the user.
 * @returns {Promise<string | null>} - The company ID or null if not found.
 */
export const fetchUserName = async (userId) => {
  const url = `/api/username/${userId}/`;
  try {
  const response = await api.get(url);

   // Check for a successful response (status code 200)
  if (response.status === 200) {
      const data = response.data;
      console.log("User Name:", data.username);
      return data.username;
    } else {
      console.error("Error fetching User Name: Unexpected status", response.status);
      return null;
    }
  } catch (error) {
    console.error("Network error:", error);
    return null;
  }
};


/**
 * Fetches the permissions list based on the user's role.
 * @returns {Promise<Object | null>} - Role details with permissions or null on failure.
 */
export const fetchUserRolePermissions = async () => {
  const userId = await fetchUserId();

  if (!userId) {
      console.error('Failed to retrieve user ID from token.');
      return null;
  }

  try {
      const response = await api.get(`/api/user/${userId}/role-permissions/`);
      // console.log("Role Permissions:", response.data.permissions);
      return response.data.permissions;
  } catch (error) {
      console.error('Error fetching role permissions:', error.response?.data || error.message);
      return null;
  }
};
